import request from '../common/request.js';

//查询操作日志列表
export function GetSysLogList(payload) {
    return request.get('/sys/GetSysLogList', payload);
}

//获取错误日志列表
export function GetErrorLogList(payload) {
    return request.get('/sys/GetErrorLogList', payload);
}

//获取错误日志详情
export function GetErrorLog(payload) {
    return request.get('/sys/GetErrorLog', payload);
}